import React from 'react';
import { bool, shape, string } from 'prop-types';

const CloseColor = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.25 7.8075L16.1925 6.75L12 10.9425L7.8075 6.75L6.75 7.8075L10.9425 12L6.75 16.1925L7.8075 17.25L12 13.0575L16.1925 17.25L17.25 16.1925L13.0575 12L17.25 7.8075Z" fill="currentColor" />
  </svg>
);

CloseColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default CloseColor;
